import { on, reducer } from 'ts-action';
import * as authActions from '../actions/auth.actions';
import { User } from '../types/auth';
import { Coworker } from '../types/coworkers.type';
import { Preferences } from '../types/preferences.type';

declare module 'react-redux' {
  interface DefaultRootState {
    auth: AuthState;
  }
}

export interface AuthState {
  user: User | null;
  preferences: Preferences | null;
  coworkers: Coworker[] | null;
}

const initialStateFactory = (): AuthState => ({
  user: null,
  preferences: null,
  coworkers: null,
});

export default reducer(
  initialStateFactory(),
  on(
    authActions.setUser,
    (state, { user }): AuthState => ({
      ...state,
      user,
    }),
  ),
  on(
    authActions.setPreferences,
    (state, { preferences }): AuthState => ({
      ...state,
      preferences,
    }),
  ),
  on(
    authActions.setCoworkers,
    (state, { coworkers }): AuthState => ({
      ...state,
      coworkers,
    }),
  ),
);
